import { render, staticRenderFns } from "./PopupMessage.vue?vue&type=template&id=c3ead864&"
import script from "./PopupMessage.vue?vue&type=script&lang=ts&"
export * from "./PopupMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports